// import core components
import dynamic from "next/dynamic";

// import custom component
const LinkNav = dynamic(() => import("@/elements/LinkNav"));
const LottieFilePlayer = dynamic(
  () => import("@/elements/Shared/LottieFilePlayer")
);

// import styles
import styles from "./otherservices.module.scss";

// import data
import ServicesList from "@/data/servicesList.json";

type Props = {
  currentServiceName: string;
};

export default function OtherServices({ currentServiceName }: Props) {
  return (
    <div className={`container ${styles["other-services-section"]}`}>
      <h2>
        Découvrez notre offre de services <strong>complète</strong>
      </h2>
      <div className={styles._other_services_content}>
        {ServicesList.map((service, i) => {
          if (service.title.toLowerCase() === currentServiceName.toLowerCase())
            return null;

          return (
            <div
              key={service.title + i}
              className={`${styles._other_services}`}
            >
              <LinkNav path={service.link} ariaLabel={service.title}>
                <>
                  <div className={styles._image_container}>
                    <LottieFilePlayer
                      className={styles["services-lottiefile"]}
                      lottieFile={service.lottieFile}
                    />
                  </div>
                  <p>{service.title}</p>
                </>
              </LinkNav>
            </div>
          );
        })}
      </div>
    </div>
  );
}
